import React from 'react';
import { Tooltip, TooltipProps } from 'antd';
import classNames from 'classnames';
import './tooltip.scss';

export type Props = TooltipProps & {};

const TooltipWrapper = (props: Props) => {
	return (
		<Tooltip {...props} overlayClassName={classNames('bringg-tooltip-overlay', props.overlayClassName)}>
			{props.children}
		</Tooltip>
	);
};

export default TooltipWrapper;
